function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 50,
  r: 10,
  fill: "#eeeeee"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  repeatCount: "indefinite",
  dur: "0.21739130434782605s",
  calcMode: "spline",
  keyTimes: "0;1",
  values: "7;0",
  keySplines: "0 0.5 0.5 1",
  begin: "0s"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill",
  repeatCount: "indefinite",
  dur: "0.8695652173913042s",
  calcMode: "discrete",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "#eeeeee;#bbbbbb;#cccccc;#dddddd;#eeeeee",
  begin: "0s"
}));

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 50,
  r: 10,
  fill: "#eeeeee"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  repeatCount: "indefinite",
  dur: "0.8695652173913042s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "0;0;7;7;7",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "0s"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "cx",
  repeatCount: "indefinite",
  dur: "0.8695652173913042s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "16;16;16;50;84",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "0s"
}));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 50,
  r: 10,
  fill: "#dddddd"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  repeatCount: "indefinite",
  dur: "0.8695652173913042s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "0;0;7;7;7",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-0.21739130434782605s"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "cx",
  repeatCount: "indefinite",
  dur: "0.8695652173913042s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "16;16;16;50;84",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-0.21739130434782605s"
}));

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 50,
  r: 10,
  fill: "#cccccc"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  repeatCount: "indefinite",
  dur: "0.8695652173913042s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "0;0;7;7;7",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-0.4347826086956521s"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "cx",
  repeatCount: "indefinite",
  dur: "0.8695652173913042s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "16;16;16;50;84",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-0.4347826086956521s"
}));

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 50,
  r: 10,
  fill: "#bbbbbb"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "r",
  repeatCount: "indefinite",
  dur: "0.8695652173913042s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "0;0;7;7;7",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-0.6521739130434782s"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "cx",
  repeatCount: "indefinite",
  dur: "0.8695652173913042s",
  calcMode: "spline",
  keyTimes: "0;0.25;0.5;0.75;1",
  values: "16;16;16;50;84",
  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
  begin: "-0.6521739130434782s"
}));

function SvgIconLoading1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "transparent",
      display: "block"
    },
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoading1);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBzdHlsZT0ibWFyZ2luOmF1dG87YmFja2dyb3VuZDogdHJhbnNwYXJlbnQ7ZGlzcGxheTpibG9jazsiIHdpZHRoPSIxMDBweCIgaGVpZ2h0PSIxMDBweCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIj4KICA8Y2lyY2xlIGN4PSI4NCIgY3k9IjUwIiByPSIxMCIgZmlsbD0iI2VlZWVlZSI+CiAgICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InIiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiBkdXI9IjAuMjE3MzkxMzA0MzQ3ODI2MDVzIiBjYWxjTW9kZT0ic3BsaW5lIiBrZXlUaW1lcz0iMDsxIiB2YWx1ZXM9Ijc7MCIga2V5U3BsaW5lcz0iMCAwLjUgMC41IDEiIGJlZ2luPSIwcyI+PC9hbmltYXRlPgogICAgICA8YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJmaWxsIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgZHVyPSIwLjg2OTU2NTIxNzM5MTMwNDJzIiBjYWxjTW9kZT0iZGlzY3JldGUiIGtleVRpbWVzPSIwOzAuMjU7MC41OzAuNzU7MSIgdmFsdWVzPSIjZWVlZWVlOyNiYmJiYmI7I2NjY2NjYzsjZGRkZGRkOyNlZWVlZWUiIGJlZ2luPSIwcyI+PC9hbmltYXRlPgogIDwvY2lyY2xlPjxjaXJjbGUgY3g9IjE2IiBjeT0iNTAiIHI9IjEwIiBmaWxsPSIjZWVlZWVlIj4KICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9InIiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiBkdXI9IjAuODY5NTY1MjE3MzkxMzA0MnMiIGNhbGNNb2RlPSJzcGxpbmUiIGtleVRpbWVzPSIwOzAuMjU7MC41OzAuNzU7MSIgdmFsdWVzPSIwOzA7Nzs3OzciIGtleVNwbGluZXM9IjAgMC41IDAuNSAxOzAgMC41IDAuNSAxOzAgMC41IDAuNSAxOzAgMC41IDAuNSAxIiBiZWdpbj0iMHMiPjwvYW5pbWF0ZT4KICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9ImN4IiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgZHVyPSIwLjg2OTU2NTIxNzM5MTMwNDJzIiBjYWxjTW9kZT0ic3BsaW5lIiBrZXlUaW1lcz0iMDswLjI1OzAuNTswLjc1OzEiIHZhbHVlcz0iMTY7MTY7MTY7NTA7ODQiIGtleVNwbGluZXM9IjAgMC41IDAuNSAxOzAgMC41IDAuNSAxOzAgMC41IDAuNSAxOzAgMC41IDAuNSAxIiBiZWdpbj0iMHMiPjwvYW5pbWF0ZT4KICA8L2NpcmNsZT48Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSIxMCIgZmlsbD0iI2RkZGRkZCI+CiAgICA8YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJyIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgZHVyPSIwLjg2OTU2NTIxNzM5MTMwNDJzIiBjYWxjTW9kZT0ic3BsaW5lIiBrZXlUaW1lcz0iMDswLjI1OzAuNTswLjc1OzEiIHZhbHVlcz0iMDswOzc7Nzs3IiBrZXlTcGxpbmVzPSIwIDAuNSAwLjUgMTswIDAuNSAwLjUgMTswIDAuNSAwLjUgMTswIDAuNSAwLjUgMSIgYmVnaW49Ii0wLjIxNzM5MTMwNDM0NzgyNjA1cyI+PC9hbmltYXRlPgogICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iY3giIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiBkdXI9IjAuODY5NTY1MjE3MzkxMzA0MnMiIGNhbGNNb2RlPSJzcGxpbmUiIGtleVRpbWVzPSIwOzAuMjU7MC41OzAuNzU7MSIgdmFsdWVzPSIxNjsxNjsxNjs1MDs4NCIga2V5U3BsaW5lcz0iMCAwLjUgMC41IDE7MCAwLjUgMC41IDE7MCAwLjUgMC41IDE7MCAwLjUgMC41IDEiIGJlZ2luPSItMC4yMTczOTEzMDQzNDc4MjYwNXMiPjwvYW5pbWF0ZT4KICA8L2NpcmNsZT48Y2lyY2xlIGN4PSI4NCIgY3k9IjUwIiByPSIxMCIgZmlsbD0iI2NjY2NjYyI+CiAgICA8YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJyIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgZHVyPSIwLjg2OTU2NTIxNzM5MTMwNDJzIiBjYWxjTW9kZT0ic3BsaW5lIiBrZXlUaW1lcz0iMDswLjI1OzAuNTswLjc1OzEiIHZhbHVlcz0iMDswOzc7Nzs3IiBrZXlTcGxpbmVzPSIwIDAuNSAwLjUgMTswIDAuNSAwLjUgMTswIDAuNSAwLjUgMTswIDAuNSAwLjUgMSIgYmVnaW49Ii0wLjQzNDc4MjYwODY5NTY1MjFzIj48L2FuaW1hdGU+CiAgICA8YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJjeCIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGR1cj0iMC44Njk1NjUyMTczOTEzMDQycyIgY2FsY01vZGU9InNwbGluZSIga2V5VGltZXM9IjA7MC4yNTswLjU7MC43NTsxIiB2YWx1ZXM9IjE2OzE2OzE2OzUwOzg0IiBrZXlTcGxpbmVzPSIwIDAuNSAwLjUgMTswIDAuNSAwLjUgMTswIDAuNSAwLjUgMTswIDAuNSAwLjUgMSIgYmVnaW49Ii0wLjQzNDc4MjYwODY5NTY1MjFzIj48L2FuaW1hdGU+CiAgPC9jaXJjbGU+PGNpcmNsZSBjeD0iMTYiIGN5PSI1MCIgcj0iMTAiIGZpbGw9IiNiYmJiYmIiPgogICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iciIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGR1cj0iMC44Njk1NjUyMTczOTEzMDQycyIgY2FsY01vZGU9InNwbGluZSIga2V5VGltZXM9IjA7MC4yNTswLjU7MC43NTsxIiB2YWx1ZXM9IjA7MDs3Ozc7NyIga2V5U3BsaW5lcz0iMCAwLjUgMC41IDE7MCAwLjUgMC41IDE7MCAwLjUgMC41IDE7MCAwLjUgMC41IDEiIGJlZ2luPSItMC42NTIxNzM5MTMwNDM0NzgycyI+PC9hbmltYXRlPgogICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iY3giIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiBkdXI9IjAuODY5NTY1MjE3MzkxMzA0MnMiIGNhbGNNb2RlPSJzcGxpbmUiIGtleVRpbWVzPSIwOzAuMjU7MC41OzAuNzU7MSIgdmFsdWVzPSIxNjsxNjsxNjs1MDs4NCIga2V5U3BsaW5lcz0iMCAwLjUgMC41IDE7MCAwLjUgMC41IDE7MCAwLjUgMC41IDE7MCAwLjUgMC41IDEiIGJlZ2luPSItMC42NTIxNzM5MTMwNDM0NzgycyI+PC9hbmltYXRlPgogIDwvY2lyY2xlPgo8L3N2Zz4=";
export { ForwardRef as ReactComponent };